const defaultPage = {page: null, redirectTo: null};

export var pageReducer = (state = defaultPage, action) => {
	switch(action.type) {
		case "SET_CURRENT_PAGE": 
			if (action.page)
				return {...state, page: action.page, redirectTo: null};

			return state;
		case "SET_REDIRECT_TO":
			if (action.redirectTo)
				return {...state, redirectTo: action.redirectTo};

			return state;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/pageReducer.js